import { AxiosRequestConfig } from 'axios';
import { isEmpty, isUndefined, isNull } from '/@/utils/is'
import { v4 as uuidv4 } from 'uuid';
import { RequestEnum } from '/@/enums/httpEnum';
import { pickBy, cloneDeep } from 'lodash-es';
import moment from 'moment'
import { encryptByHmacSHA256 } from '/@/utils/cipher'
import qs from 'qs';
import { getAppEnvConfig } from "/@/utils/env";

const { VITE_JWT_APPID, VITE_SIGN_SECRET } = getAppEnvConfig();

type SignData = {
  appId: string,
  reqId?: string, // 客户端唯一，服务端会用这个参数进行幂等校验
  timestamp: number, // 请求时间 YYYYMMDDHHmmss格式
  version: string, // 当前版本号
  signType: 'MD5' | 'HMAC-SHA256', // 签名类型
  sign?: string, // 签名
  reqData?: object, // 请求体参数
}

const getData = (config: AxiosRequestConfig) => {

  let query = {};
  let body = {};
  if (config && config.params) query = config.params
  if (config && config.data) body = config.data
  // 处理url上的参数
  if (query && !isEmpty(query)) {
    const keys = Object.keys(query).sort();
    for (let index = 0; index < keys.length; index++) {
      const k = keys[index];
      if (isNull(query[k]) || isUndefined(query[k])) {
        delete query[k]
      }
    }
  }
  // 处理data的参数
  if (body && !isEmpty(body)) {
    body = pickBy(body, value => {
      return !isEmpty(value) && !isUndefined(value) && !isNull(value)
    })
  }
  return { query, body }
}

const orderBy = (obj: object): any => {
  if (isEmpty(obj)) return {}
  let result: object = {}
  Object.keys(obj).sort().forEach(k => {
    result[k] = obj[k]
  })
  return result
}


export function formatSignData(config: AxiosRequestConfig): SignData {
  let CloneConfig: AxiosRequestConfig = cloneDeep(config); 
  let RequestData: SignData = {
    appId:VITE_JWT_APPID!,
    timestamp: moment().valueOf(),
    version: 'v1.0',
    signType: 'HMAC-SHA256',
    reqId: uuidv4().replaceAll('-', ''),
  }
  // 处理参数
  const { body, query } = getData(config)
  // if (!isEmpty(body) || !isEmpty(query)) {
  //   // 参数赋值
  //   RequestData.reqData = CloneConfig.method === RequestEnum.POST ? body : query;
  // }
    RequestData.reqData =
      CloneConfig.method === RequestEnum.POST ? body : query;

  // 排序
  RequestData = { ...orderBy(RequestData) }
  // encode object
  const QsStringfy = qs.stringify(
    {
      ...RequestData,
      reqData: JSON.stringify(RequestData.reqData),
      signSecret: VITE_SIGN_SECRET, // signSecret不参与序列化直接拼在后面
    },
    { encode: false }
  );
  // SHA256签名
  // appId="20211218121857gutk"&reqData={"nextBrandId":"001","num":"100"}&reqId="202112290001"&signType="HMAC-SHA256"&timestamp=1640769747123&version="v1.0"&signSecret=zcKFb1MndVk8l1515obdzHGF
  RequestData.sign = encryptByHmacSHA256(QsStringfy, VITE_SIGN_SECRET!);
  return RequestData;
}